export const NAME = 'userSession'

export const CLIENT_SETTINGS_GET = 'clientSettingsGet'
export const ENROLLMENT_RESPONSES_GET = 'enrollmentResponsesGet'
